<template>
  <div class="headline-author-wrapper">
    <span v-if="authorNames" class="headline-author">{{ authorNames }}</span>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { Headline } from '@headlines/types/headline';

interface Props {
  authors: Headline['authors'];
}

interface Computed {
  authorNames: string | boolean;
}

export default Vue.extend<unknown, unknown, Computed, Props>({
  name: 'HeadlineAuthor',
  props: {
    authors: {
      type: Object,
      required: true,
    },
  },
  computed: {
    authorNames() {
      const names: Array<string> = [];

      if (this.authors.items.length) {
        this.authors.items.forEach((author) => {
          names.push(author.name);
        });
      }

      return names.join(', ') || false;
    },
  },
});
</script>
<style lang="scss">
.headline-author-wrapper {
  margin: 15px 0 0 0;
  line-height: 15px;

  @include media-breakpoint-down(md) {
    margin: 0 0 15px 0;
  }
}

.headline-author {
  display: inline;
  margin: 0;
  font-family: get-font-family('system');
  font-size: 10px;
  font-weight: get-font-weight('semi-bold');
  line-height: 15px;
  vertical-align: top;
}
</style>
